import AnalyticsService from "@/services/analytics";
import { atom, useAtom } from "jotai";

export const getInTouchModalOpenAtom = atom(false);

export function useGetInTouchModal() {
  const [getInTouchModal, setGetInTouchModal] = useAtom(getInTouchModalOpenAtom);

  const showGetInTouchModal = () => {

    AnalyticsService.trackGAEventHandler("appFeedbackOpen");
    AnalyticsService.trackMx("appFeedbackOpen", {});

    // console.log("show");
    setGetInTouchModal(true);
  };

  const hideGetInTouchModal = () => {
    // console.log("hide");

    AnalyticsService.trackGAEventHandler("appFeedbackClose");
    AnalyticsService.trackMx("appFeedbackClose", {});

    setGetInTouchModal(false);
  };

  return {
    showGetInTouchModal,
    hideGetInTouchModal,
    isGetInTouchModalVisible: getInTouchModal,    
  };
}
